
import XHeader from 'vux/src/components/x-header/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getProfile } from "../../common/js/api.js";
import { wxORzfb } from "../../common/js/config.js";


export default {
components: {
XHeader,
XSwitch,
Group,
CellBox,
Cell
},
methods: {
getProfile() {
let self = this;
getProfile().then(function(data) {
self.entity = data.Content;
});
}
},
data() {
return {
title: "我的",
isVirtual: true,
isMobileValid: false,
wechat:1,
entity: {
avatar: ""
}
};
},
created() {
this.wechat = wxORzfb == 'wx'? 1 : 0
this.getProfile()

}
};



// WEBPACK FOOTER //
// ./src/components/usercenter/Index.vue